/**
 * @param {Object} date date object e.g. new Date().
 * @return {Object} UTC date
 */
function convertToUTC(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

/** to return this date string format: 2019-01-31T00:00:00.000
 * @param {Object} utcDate
 * @return {String}
 */
function toLocalISOString(utcDate) {
  utcDate.toISOString().replace('Z', '');
}

/** to return this date string format: 2019-01-31T00:00:00.000
 * @param {Object} date
 * @return {String}
 */
export default function toUTCLocalISOString(date) {
  return toLocalISOString(convertToUTC(date));
}
